(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["af-bundle-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    function init(scope) {
      scope.querySelectorAll('[data-af-bundle]').forEach(bundle => {
        if (bundle.dataset.ready) return;
        const root = bundle.closest('[data-product-detail]');
        const form = root?.querySelector('.af-product-form');
        const quantity = form?.querySelector('[name="quantity"]');
        const select = form?.querySelector('[data-product-variant-select]');
        const json = root?.querySelector('[data-product-variants-json]');
        if (!quantity || !select || !json) return;
        let variants;
        try { variants = JSON.parse(json.textContent); } catch { return; }
        bundle.dataset.ready = '1';
        root.classList.add('af-bundle-enabled');
        const cards = [...bundle.querySelectorAll('[data-bundle-tier]')];
        const reset = bundle.querySelector('[data-bundle-reset]');
        const more = bundle.querySelector('[data-bundle-more]');
        const extra = bundle.querySelector('[data-bundle-quantity]');
        const summary = bundle.querySelector('[data-bundle-summary]');
        const hint = summary.textContent;
        const price = root.querySelector('[data-product-price]');
        const priceContext = root.querySelector('[data-product-price-context]');
        const old = root.querySelector('[data-product-compare-price]');
        const money = new Intl.NumberFormat('en-PK', {style:'currency',currency:bundle.dataset.currency || 'PKR',maximumFractionDigits:2});
        let tier = 0;
        let selectedVariantId = String(select.value);
        let frame = 0;
        const format = cents => money.format(cents / 100);
        function variant() { return variants.find(v => String(v.id) === String(select.value)); }
        function thresholds(v) { return /^1\s*(l|liter|litre)$/i.test(v.title.trim()) ? [1,2,4,6] : [1,2,3,4]; }
        function text(el, value) { if (el && el.textContent !== value) el.textContent = value; }
        function paint() {
          const v = variant();
          if (!v) return;
          const steps = thresholds(v);
          const q = Math.max(1, parseInt(quantity.value,10) || 1);
          tier = q >= steps[3] ? 3 : q >= steps[2] ? 2 : q >= steps[1] ? 1 : 0;
          const percent = [0,5,10,12][tier];
          const regular = v.price * q;
          const total = regular - Math.round(regular * percent / 100);
          const comparison = percent ? regular : Math.max(v.price, v.compare_at_price || 0) * q;
          cards.forEach((card,index) => {
            text(card.querySelector('[data-bundle-buy]'), bundle.dataset.buy.replace('__Q__',steps[index+1]) + (index === 2 ? '+' : ''));
            card.setAttribute('aria-pressed', String(tier === index + 1));
            card.disabled = !v.available;
          });
          reset.setAttribute('aria-pressed',String(q === 1));
          more.hidden = tier !== 3;
          extra.min = steps[3];
          extra.value = q;
          text(price, format(total));
          text(priceContext,q > 1 ? bundle.dataset.total.replace('__Q__',q) : '');
          if (old) { text(old,comparison > total ? format(comparison) : ''); old.classList.toggle('is-hidden', comparison <= total); }
          text(summary,q > 1 ? bundle.dataset.total.replace('__Q__',q) + ' · ' + format(total) : hint);
          const label = (percent ? bundle.dataset.addDiscount : bundle.dataset.add).replace('__Q__',q).replace('__P__',percent);
          const add = form.querySelector('[data-product-add-icon]');
          if (v.available && add && !add.disabled) {
            text(form.querySelector('[data-product-add-text]'),label);
            text(root.querySelector('[data-mobile-add]'),label);
          }
          text(root.querySelector('[data-mobile-price]'),format(total));
        }
        function choose(next) {
          quantity.value = String(next);
          quantity.dispatchEvent(new Event('input',{bubbles:true}));
          quantity.dispatchEvent(new Event('change',{bubbles:true}));
          paint();
        }
        cards.forEach((card,index) => card.addEventListener('click',() => {
          const v = variant();
          if (v?.available) choose(thresholds(v)[index+1]);
        }));
        reset.addEventListener('click',() => choose(1));
        extra.addEventListener('change',() => choose(Math.max(Number(extra.min),parseInt(extra.value,10) || Number(extra.min))));
        function syncVariant() {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const v = variant();
            if (!v) return;
            const changed = String(v.id) !== selectedVariantId;
            selectedVariantId = String(v.id);
            if (changed) choose(1);
            else paint();
          });
        }
        root.addEventListener('click',event => { if (event.target.closest('[data-product-option-button]')) syncVariant(); });
        select.addEventListener('change',syncVariant);
        quantity.addEventListener('input',() => paint());
        quantity.addEventListener('change',() => paint());
        requestAnimationFrame(() => paint());
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document));
    else init(document);
    document.addEventListener('shopify:section:load',event => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mustard-value-picker"] && !Shopify.designMode) return;
  try {
    (function(){
    function initVolumeBreaks(root){
      (root || document).querySelectorAll('[data-af-value-picker]').forEach(function(picker){
        if(picker.dataset.volumeBreaksReady === '1') return;
        var breaks = picker.querySelector('[data-af-volume-breaks]');
        if(!breaks) return;
        picker.dataset.volumeBreaksReady = '1';

        var productRoot = picker.closest('[data-product-detail]');
        var quantityInput = productRoot && productRoot.querySelector('.af-product-form [name="quantity"]');
        var variantSelect = productRoot && productRoot.querySelector('[data-product-variant-select]');
        var breakButtons = Array.prototype.slice.call(breaks.querySelectorAll('[data-af-quantity-break]'));

        if(productRoot) productRoot.classList.add('af-volume-breaks-enabled');

        function setQuantity(button, notify){
          if(!button || !quantityInput) return;
          var quantity = Math.max(1, parseInt(button.dataset.quantity || '1', 10) || 1);
          breakButtons.forEach(function(candidate){
            var active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          quantityInput.value = String(quantity);
          if(notify){
            quantityInput.dispatchEvent(new Event('input', {bubbles: true}));
            quantityInput.dispatchEvent(new Event('change', {bubbles: true}));
          }
        }

        function updateBreakOptions(activeSize){
          if(!activeSize) return;
          var oneLitre = activeSize.dataset.volumeScheme === 'one-litre';
          var unitPrice = Math.max(0, Number(activeSize.dataset.unitPrice || 0));

          breakButtons.forEach(function(button){
            var quantityKey = oneLitre ? 'oneLitreQuantity' : 'standardQuantity';
            var quantity = Math.max(1, parseInt(button.dataset[quantityKey] || '1', 10) || 1);
            var discount = Math.max(0, Number(button.dataset.discountPercent || 0));
            var plus = button.dataset.plus === 'true' ? '+' : '';
            var buy = button.querySelector('[data-af-break-buy]');
            var price = button.querySelector('[data-af-break-price]');
            var label = (button.dataset.selectTemplate || '').replace('__QUANTITY__', String(quantity)) + plus;

            button.dataset.quantity = String(quantity);
            button.setAttribute('aria-label', label);
            if(buy) buy.textContent = (buy.dataset.buyTemplate || '').replace('__QUANTITY__', String(quantity)) + plus;
            if(price && typeof window.formatMoney === 'function'){
              var discountedTotal = Math.round(unitPrice * quantity * (100 - discount) / 100);
              price.textContent = window.formatMoney(discountedTotal);
            }
          });
        }

        function syncVariant(notify){
          var activeSize = picker.querySelector('[data-af-size-option].is-active');
          updateBreakOptions(activeSize);
          picker.querySelectorAll('[data-af-size-option]').forEach(function(sizeButton){
            sizeButton.setAttribute('aria-checked', sizeButton.classList.contains('is-active') ? 'true' : 'false');
          });
          setQuantity(breakButtons[0], notify);
        }

        breakButtons.forEach(function(button){
          button.addEventListener('click', function(){ setQuantity(button, true); });
        });
        picker.querySelectorAll('[data-af-size-option]').forEach(function(button){
          button.addEventListener('click', function(){
            window.requestAnimationFrame(function(){ syncVariant(true); });
          });
        });
        if(variantSelect) variantSelect.addEventListener('change', function(){ syncVariant(true); });
        setQuantity(breakButtons[0], false);
        syncVariant(false);
      });
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ initVolumeBreaks(document); });
    }else{
      initVolumeBreaks(document);
    }
    document.addEventListener('shopify:section:load', function(event){ initVolumeBreaks(event.target || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-volume-breaks"] && !Shopify.designMode) return;
  try {
    (function(){
    function initProductVolumeBreaks(root){
      (root || document).querySelectorAll('[data-af-product-volume-breaks]').forEach(function(breaks){
        if(breaks.dataset.ready === '1') return;
        var productRoot = breaks.closest('[data-product-detail]');
        var form = breaks.closest('form');
        var quantityInput = form && form.querySelector('[name="quantity"]');
        var variantSelect = form && form.querySelector('[data-product-variant-select]');
        var addButton = form && form.querySelector('[data-product-add-icon]');
        var addText = form && form.querySelector('[data-product-add-text]');
        var mobileAdd = productRoot && productRoot.querySelector('[data-mobile-add]');
        var buttons = Array.prototype.slice.call(breaks.querySelectorAll('[data-af-product-quantity-break]'));

        if(!quantityInput || !buttons.length) return;
        breaks.dataset.ready = '1';
        if(productRoot) productRoot.classList.add('af-volume-breaks-enabled');

        function updateButtonLabel(button){
          if(addButton && addButton.disabled) return;
          var quantity = Math.max(1, parseInt(button.dataset.quantity || '1', 10) || 1);
          var discount = Math.max(0, parseInt(button.dataset.discountPercent || '0', 10) || 0);
          var template = discount > 0 ? button.dataset.addDiscountTemplate : button.dataset.addTemplate;
          var label = (template || '').replace('__QUANTITY__', String(quantity)).replace('__PERCENT__', String(discount));

          if(addText) addText.textContent = label;
          if(mobileAdd) mobileAdd.textContent = label;
        }

        function choose(button, notify){
          var quantity = Math.max(1, parseInt(button.dataset.quantity || '1', 10) || 1);
          buttons.forEach(function(candidate){
            var active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          quantityInput.value = String(quantity);
          updateButtonLabel(button);
          if(notify){
            quantityInput.dispatchEvent(new Event('input', {bubbles: true}));
            quantityInput.dispatchEvent(new Event('change', {bubbles: true}));
          }
        }

        buttons.forEach(function(button){
          button.addEventListener('click', function(){ choose(button, true); });
        });
        if(variantSelect){
          variantSelect.addEventListener('change', function(){
            window.setTimeout(function(){
              choose(buttons[0], true);
            }, 0);
          });
        }
        choose(buttons[0], false);
        window.setTimeout(function(){
          var active = breaks.querySelector('.is-active');
          if(active) updateButtonLabel(active);
        }, 500);
      });
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ initProductVolumeBreaks(document); });
    }else{
      initProductVolumeBreaks(document);
    }
    document.addEventListener('shopify:section:load', function(event){ initProductVolumeBreaks(event.target || document); });
  })();
  } catch(e) { console.error(e); }
})();

})();
